import { render, staticRenderFns } from "./EmptyScreenApplication.vue?vue&type=template&id=78eff972&scoped=true&"
var script = {}
import style0 from "./EmptyScreenApplication.vue?vue&type=style&index=0&id=78eff972&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78eff972",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
